export enum PrioridadEnum {
    Alta = 'Alta',
    Media = 'Media',
    Baja = 'Baja'
}
